import { BACKEND_BASE_URL, IResponseError } from "@/services";
import { IUsersGuideService } from "@/services/backend/usersguide/usersguide.types";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";

export class UsersGuideService implements IUsersGuideService {
  async getUsersGuide(): Promise<string | undefined> {
    const { response, error } = await handleResponse<string, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/users_guide`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
